module.exports = {
  api: 'https://www.hepsiburada.com/api/v1',
  baseUrl: 'http://localhost:8080',
};



// WEBPACK FOOTER //
// ./src/conf/config.js